"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./IconItem.css");
var icons_1 = require("@tiendanube/icons");
var Link_1 = __importDefault(require("../Link"));
var Text_1 = __importDefault(require("../Text"));
function IconItem(_a) {
    var Icon = _a.icon, _b = _a.appearance, appearance = _b === void 0 ? "default" : _b, title = _a.title, subtitle = _a.subtitle, link = _a.link, _c = _a.shape, shape = _c === void 0 ? "circle" : _c;
    var classname = (0, classnames_1.default)({
        "shape-square": shape === "square",
    }, "nimbus--icon-item__icon--".concat(appearance));
    var renderTitle = title && React.createElement(Text_1.default, null, title);
    var renderSubtitle = subtitle && React.createElement(Text_1.default, null, subtitle);
    var renderLink = link && (React.createElement(Link_1.default, { icon: icons_1.ExternalLinkIcon, iconPosition: "end", href: link.href, onClick: link.onClick }, link.children));
    return (React.createElement("div", { className: "nimbus--icon-item", role: "status" },
        React.createElement("div", { className: classname, "aria-label": title }, Icon && React.createElement(Icon, null)),
        (title || subtitle || link) && (React.createElement("div", { className: "nimbus--icon-item__info" },
            renderTitle,
            renderSubtitle,
            renderLink))));
}
exports.default = IconItem;
//# sourceMappingURL=index.js.map